import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 13.061,
	viewBox: "0 0 13.061 13.061",
	width: 13.061,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5,
		children: [/* @__PURE__ */ _jsx("path", { d: "m12.53 12.53-12-12" }), /* @__PURE__ */ _jsx("path", { d: "m12.53.53-12 12" })]
	})
});
export default SvgCross;
